import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-stone-200 bg-white py-10 sm:py-14" data-id="element-191" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-192" data-mp="1t8nkw5sh7hrh">
        <h2 className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-red-600" data-id="element-193" data-mp="1oac9vrqg317o">
          Los Números No Mienten
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0" data-id="element-194" data-mp="1jeoir6sejxzj">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-stone-200' : ''}`} data-id="element-195" data-mp="19mr5luhu2vy6" data-mpi={index}>
              <dt className="sr-only" data-id="element-196" data-mp="10m2r6yoj2tkr">{stat.label}</dt>
              <dd data-id="element-197" data-mp="10nds8qql9n86">
                <span className="block font-serif text-3xl font-black text-stone-900 sm:text-4xl" data-id="element-198" data-mp="10jq3s6003r0b">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500 sm:text-xs" data-id="element-199" data-mp="qoob506io6sz">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}